import React, { ReactElement } from 'react';
import DeleteWidgetModal from 'adapter/in/dashboards/pages/Widget/DeleteWidgetModal';
import useDeleteWidget from 'adapter/in/dashboards/hooks/Widget/useDeleteWidget';

type DeleteWidgetModalContainerProps = {
    dashboardId: string;
    widgetId: string;
    showModal: boolean;
    setShowModal: (show: boolean) => void;
};

const DeleteWidgetModalContainer = (props: DeleteWidgetModalContainerProps): ReactElement => {
    const { dashboardId, showModal, setShowModal, widgetId } = props;

    const { delete: deleteWidget, isLoading, success, error } = useDeleteWidget(dashboardId, widgetId);

    return (
        <DeleteWidgetModal
            showModal={showModal}
            success={success}
            setShowModal={setShowModal}
            onDelete={deleteWidget}
            isLoading={isLoading}
            error={error}
        />
    );
};

export default DeleteWidgetModalContainer;
